/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React from 'react';
import {Text, StyleSheet, SafeAreaView, Image, ActivityIndicator, Dimensions} from 'react-native';

const entireScreenWidth = Dimensions.get('window').width;
Dimensions.get('window').height;
const Loader = (props) => {
return (
    <SafeAreaView style={styles.loader}>
     <Image
     style={styles.loaderImage}
     source={require('../../assets/infernoIcon.png')}
    />
    <ActivityIndicator size="large" color="white" style={styles.loaderSpinner}/>
    <Text style={styles.loaderText}>Loading...</Text>
    </SafeAreaView>
)
}

const styles = StyleSheet.create({
loader: {
      flex: 1,
      backgroundColor: 'black',
      justifyContent: 'center'
      },
      loaderText: {
      flex: 1,
      color: 'white',
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: 20,
      paddingTop: 10
      },
      loaderImage: {
      flex: 1,
      resizeMode: 'contain',
      width: entireScreenWidth,
      alignSelf: 'center',
     },
});

export default Loader;